import { Paper, Stack, Typography } from 'styles';
import palette from 'styles/theme/Palette';
import { ISettlementLettersDocument } from 'types/SettlementLetters';
import { TRANSLATION_KEYS } from 'utils/constants';
import { useTranslation } from 'utils/translations';

type Props = {
	documents: ISettlementLettersDocument[];
	selectedDocId: string | undefined;
	onSelectDocument: (uuid: string) => void;
};

const DocumentsList = ({
	documents,
	selectedDocId,
	onSelectDocument,
}: Props) => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});

	const handleClick = (uuid: string) => {
		onSelectDocument(uuid);
	};

	return (
		<Stack gap={'10px'}>
			{documents.length === 0 && (
				<Typography variant="body">
					{tClientLabels('view-settlement-letters.noDocuments')}
				</Typography>
			)}

			{documents.map(doc => (
				<Paper
					key={doc.uuid}
					elevation={0}
					onClick={() => handleClick(doc.uuid)}
					sx={{
						paddingX: '10px',
						paddingY: '10px',
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'flex-start',
						'&:hover': {
							backgroundColor:
								doc.uuid === selectedDocId ? palette.white.main : palette.grey5.main,
						},
						border:
							doc.uuid === selectedDocId
								? `1px solid ${palette.primary.main}`
								: `1px solid ${palette.white.main}`,
					}}
				>
					<Stack gap={1}>
						<Typography variant="bodyLink">{`${doc.name}`}</Typography>
					</Stack>
				</Paper>
			))}
		</Stack>
	);
};

export default DocumentsList;
